/** Pure decision function for the attention-banner.
 *
 * Centralised here so component tests can pin behaviour without rendering
 * React. Bug 2026-05-08: a card in `ocr_running` (data.days = `{}`) rendered
 * the green "all-clear" banner because empty breakdown → need=0 → "alle
 * geprüft". The fix routes pre-OCR + in-flight states to a wait-banner
 * regardless of breakdown counts.
 */

const OCR_IN_FLIGHT = new Set(["uploaded", "ocr_pending", "ocr_running"]);

export type AttentionBannerVariant =
  | { kind: "ocr_in_flight"; label: string }
  | { kind: "all_done" }
  | { kind: "needs_attention"; need: number };

export function attentionBannerVariant(
  cardState: string | undefined,
  need: number,
): AttentionBannerVariant {
  if (cardState && OCR_IN_FLIGHT.has(cardState)) {
    const label = cardState === "uploaded" ? "OCR noch nicht gestartet" : "OCR läuft, bitte warten";
    return { kind: "ocr_in_flight", label };
  }
  if (need === 0) {
    return { kind: "all_done" };
  }
  return { kind: "needs_attention", need };
}
